// extracted by mini-css-extract-plugin
export default {"profileConsoleContainer":"ProfileConsole_profileConsoleContainer__t6zMn","tabsContainer":"ProfileConsole_tabsContainer__n4y03","centeredTabs":"ProfileConsole_centeredTabs__jDBoj"};